module.exports = __webpack_public_path__ + "media/images/emblems/Taesch-coat_of_arms-4ef313d8b8b316442c8a39e6d43ccc40.svg";